const PHRASES = [
  "Treat the tension",
  "Understand the body",
  "Massage beyond muscles",
  "A space to exhale",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {PHRASES.map((p, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-10 font-serif text-3xl font-light italic tracking-wide text-walnut/80 lg:text-4xl">
          {p}
        </span>
        <span className="h-[6px] w-[6px] rounded-full bg-gold" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="overflow-hidden border-y border-walnut/20 bg-ivory py-10"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
